@if (navLinks()) { @for (navLink of navLinks()?.children; track navLink; let i = $index) {
<li class="dropdown main-nav dotcms-custom-menu">
  @if (navLink.type !== 'folder') {
  <a [routerLink]="dotCMSHeaderNavigationLink(navLink?.href)">{{ navLink?.title }}</a>
  } @else { @if (navLink?.children?.length > 0) {
  <div
    (mouseenter)="manageLeft(i, $event)"
    [ngClass]="'link' + i"
    [id]="'link' + i"
    class="dropdown dot-cms-header-nav"
  >
    <custom-dot-cms-uve-header-folder-index-page-check
      [navLink]="navLink"
      [dropDownLayer]="i"
      [depth]="i - i"
      deviceType="desktop"
    />
    @if (0 < mainNavigationMaxSubCategoriesDepth && navLink?.children?.length > 0) {
    <div
      #nav
      [attr.id]="'dot-cms-header-flyout' + i"
      class="dotcms-flyout d-none"
      [ngClass]="'dot-cms-header-flyout' + i"
    >
      @if (navLink?.children?.length > 0) {
      <!--This is the sub folder container -->
      <ul>
        <custom-dot-cms-sub-folder-header-navigation
          [subFolderItems]="navLink?.children"
          [depth]="depth"
          [folderIndex]="i"
          deviceType="desktop"
        />
      </ul>
      }
    </div>
    }
  </div>
  } @else {
  <div class="dot-cms-header-nav">
    <div class="disable-links0 empty-folder">{{ navLink?.title }}</div>
  </div>
  } }
</li>
} }
